import React from 'react';
import { useSelector } from 'react-redux';
import ImageToolbar from './toolbars/ImageToolbar';
import VideoToolbar from './toolbars/VideoToolbar';
import { useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import { Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const VImageToolbar = props => {
  // const { activePageRef } = useContext(DesignContext);
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const entity = useSelector(state => state.design.entitiesState[selectedEntity.id]);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  let entityType, cropBtn;

  if (selectedEntity.type === 'ImageBackground') {
    entityType = 'Image';
    cropBtn = false;
  } else if (selectedEntity.type === 'VideoBackground') {
    entityType = 'Video';
    cropBtn = false;
  } else if (selectedEntity.type === 'Frame') {
    entityType = _.get(entity, 'data.medias.frame.type', 'Frame');
    if (entityType === 'Image' || entityType === 'Video') {
      cropBtn = true;
    } else {
      cropBtn = false;
    }
  } else {
    entityType = _.get(entity, 'type');
    cropBtn = entityType ? true : false;
  }

  const editMode = () => {
    dispatch(designActions.changeEditableMode({ id: selectedEntity.id, editable: true }));
  };

  return (
    <>
      {cropBtn && (
        <Button className="button text" title="Crop" onMouseDown={editMode}>
          <span>{t('crop')}</span>
        </Button>
      )}
      {entityType === 'Image' && <ImageToolbar />}
      {entityType === 'Video' && <VideoToolbar selectedEntity={props.selectedEntity} />}
    </>
  );
};

export default VImageToolbar;
